// This document was created 07/11/2024 to allow custom JavaScript code to be injected into the theme for additional functionality without diluting the existing code. 
// Please maintain this and. update the change doc as and when changes occur.

// Form Submission Confirmation
document.addEventListener("DOMContentLoaded", function(event) { 
  if (window.location.href.indexOf("?contact_posted=true#Contact_Form") > -1) {
    document.getElementById('request-confirm-POA').style.display = 'block';
  } else if (window.location.href.indexOf("?contact_posted=true") > -1) {
    document.getElementById('request-confirm-POA').style.display = 'block';
  }
});